import{j as e}from"./chunk-GEPA7FLG.js";e();import{gql as r}from"@apollo/client";var a=r`
  query registerGroupSettings($address: String!) {
    registerGroupSettings(address: $address) {
      tokens {
        name
        identifier
        balance
        decimals
        ticker
        assets {
          svgUrl
          pngUrl
        }
      }
      nfts {
        collection
        name
        ticker
        assets {
          svgUrl
          pngUrl
        }
      }
      registerGroupFee
      contractDeploymentFee
      registerGroupFeeToken {
        name
        identifier
        balance
        decimals
        ticker
        assets {
          svgUrl
          pngUrl
        }
      }
      contractDeploymentFeeToken {
        name
        identifier
        balance
        decimals
        ticker
        assets {
          svgUrl
          pngUrl
        }
      }
    }
  }
`;export{a};
//# sourceMappingURL=chunk-QLMYSIXN.js.map
